import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CampaignTerminalsViewTable } from "./CampaignTerminalsViewTable";

export const CampaignTerminalsViewTableField: FieldMethod = ({ field }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <CampaignTerminalsViewTable />
        </Form.Item>
    );
};
